import { put, takeLatest, select } from 'redux-saga/effects';
import breadCrumbInfo from '../selectors/PDPBreadCrumbsSelector';
import {
    BREADCRUMBS_GET_SUCCESS,
    BREADCRUMBS_GET_FAILURE,
    BREADCRUMBS_GET_REQUEST,
} from '../actionTypes/PDPBreadcrumbsActionTypes';

function* fetchPDPBreadcrumbs() {
    try {
        const breadcrumbsData = yield select(breadCrumbInfo);

        yield put({
            type: BREADCRUMBS_GET_SUCCESS,
            payload: {
                breadcrumbsData,
            },
        });
    } catch (error) {
        yield put({
            type: BREADCRUMBS_GET_FAILURE,
            error,
        });
    }
}

const watchPDPBreadcrumbsSaga = function* watchPDPBreadcrumbsSaga() {
    yield takeLatest(BREADCRUMBS_GET_REQUEST, fetchPDPBreadcrumbs);
};

watchPDPBreadcrumbsSaga.sagaName = 'pdpBreadcrumbsSaga';

export default watchPDPBreadcrumbsSaga;
